/* eslint-disable */ import { materialSwatchComponent, memoEval, sceneEntityObjectRemoteMaterialOverrideComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { ColorOak } from '../model/index.js';
export const oakLegsComponents = [
    attachComponent.withComponent(materialSwatchComponent, 'legsColor', true).withAlias('OakLegs').attach(memoEval((self)=>[
            self.$legsColorSwatches,
            self.color
        ], ($legsColorSwatches, color)=>({
            swatches: $legsColorSwatches,
            selectedSwatchKey: color
        })), (state)=>{
        ColorOak.assert(state.selectedSwatchKey);
        return {
            color: state.selectedSwatchKey
        };
    }),
    attachComponent.withComponent(sceneEntityObjectRemoteMaterialOverrideComponent, 'body', true).withAlias('OakLegs').attach(memoEval((self)=>[
            self.$materialColor,
            self.$textureUrl,
            self.$normalMapUrl,
            self.$roughnessMapUrl
        ], ($materialColor, $textureUrl, $normalMapUrl, $roughnessMapUrl)=>({
            materialsToOverride: [
                'LegsMaterial'
            ],
            fileUrl: '/models/algu3d.glb',
            materialName: 'LegsMaterial',
            roughness: 1,
            color: $materialColor,
            textureUrl: $textureUrl,
            normalMapUrl: $normalMapUrl,
            roughnessMapUrl: $roughnessMapUrl
        })))
];

//# sourceMappingURL=oak-legs.js.map